// Central testIds used by frontend + testing agent.
export const HOME = {
  emergentLink: "home-emergent-link",
  heroPrimaryCta: "home-hero-primary-cta",
  heroSecondaryCta: "home-hero-secondary-cta",
};

export const NAV = {
  headerLogoLink: "header-logo-link",
  headerLetsTalk: "header-lets-talk-button",
  footerNav: "footer-nav",
};

export const CONTACT = {
  calendar: "contact-scheduler-calendar",
  timeSlot: "contact-time-slot-button",
  radioCard: "contact-preference-radio-card",
  nameInput: "contact-details-name-input",
  orgInput: "contact-details-org-input",
  emailInput: "contact-details-email-input",
  notesTextarea: "contact-details-notes-textarea",
  submit: "contact-scheduler-submit-button",
};

export const CAREERS = {
  openTalentNetwork: "careers-talent-network-open-button",
  talentSubmit: "careers-talent-network-submit-button",
};

export const DONATE = {
  cadenceOneTime: "donate-cadence-one-time",
  cadenceMonthly: "donate-cadence-monthly",
  tierButton: "donate-tier-button",
  customInput: "donate-custom-amount-input",
  submit: "donate-submit-button",
};
